import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/react-hooks'

import EvIframe from '../../../../containers/shared/evergent-iframe'
import { LoadingModal } from '../../../loading/modal'
import SUBSCRIPTION_CREDITCARD_VIEW_QUERY from '../../../../../graphql/queries/subscription-creditcard-view.gql'
import styles from './subscription-creditcard.css'

/**
 * Loads and displays the payment-card form, then advances to confirmation when
 * payment is already resolved or the iframe reports a successful submission.
 */
function SubscriptionCreditcard({ renderStep }) {
  const {
    data,
    loading,
    error
  } = useQuery(SUBSCRIPTION_CREDITCARD_VIEW_QUERY, {
    fetchPolicy: 'network-only'
  })

  const subscriptionCreditcardView = data?.subscriptionCreditcardView
  const header = subscriptionCreditcardView?.header
  const message = subscriptionCreditcardView?.message
  const orderId = subscriptionCreditcardView?.orderId
  const iframe = subscriptionCreditcardView?.iframe

  useEffect(() => {
    // An order ID means payment is already resolved, so skip card entry and show confirmation.
    if (orderId) {
      renderStep(2, { orderId })
    }
  }, [orderId, renderStep])

  const onIframeLoad = useCallback((iframeQueryParams) => {
    if (iframeQueryParams?.status !== 'success') return

    renderStep(2, { orderId: iframeQueryParams.orderId })
  }, [renderStep])

  if (loading || error || iframe == null) {
    return <LoadingModal />
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h1 className={styles.header}>
          { header || 'Add payment details' }
        </h1>
        <p className={styles.message}>
          { message || 'Please provide your credit card details below to complete your account set up.' }
        </p>
        <div className={styles.iframeWrapper}>
          <EvIframe
            src={iframe}
            onLoad={onIframeLoad}
          />
        </div>
      </div>
    </div>
  )
}

SubscriptionCreditcard.propTypes = {
  renderStep: PropTypes.func.isRequired
}

export default SubscriptionCreditcard
